import { $campaigns } from '@/services/'
export const campaignMixin = {
  computed: {
    dnsAlertDisplayClass () {
      if((this.$store.state.ui.folder.show || this.$store.getters['ui/folder'].id) && this.$vuetify.breakpoint.smAndUp){
        return 'multi-line mt-n3 mb-5'
      }
      else if(this.$vuetify.breakpoint.smAndUp){
        return 'multi-line mt-n3 ml-n12'
      }
      else{
        return 'multi-line ml-n3'
      }
    },
  },
  methods: {
    watchCollection(arr, cb) {
      arr.forEach((val) => this.$watch(val, cb))
    },
    stepHandler () {
      if(this.$store.state.campaign.currentStep <= this.$store.state.campaign.finishedStep)
        this.$store.state.campaign.finishedStep = this.$store.state.campaign.currentStep - 1
    },
    contactInfo(selectedItems, select_all, type) {
      if (selectedItems.length > 0 && !select_all && !type.includes('suppress')) {
        let flag = false
        let contactCount = type.includes('list') ?  'subscribers' : 'contacts_count'
        for (var i = 0; i < selectedItems.length; i++) {
          if (selectedItems[i][contactCount] != null && selectedItems[i][contactCount] > 0) {
            flag = true;
            break;
          }
        }
        if (!flag) {
          this.$store.commit('ui/snackbar', { message: `You have selected ${type}(s) having 0 contacts for this campaign. The campaign will not be send unless you have at least 1 contact selected.`, type: 'warning' })
        }
      }
    },
    hasDnsSetup(){
      $campaigns.getDefaultSendingDomain()
      .then((response) => {
        if(response.data.data.dkim_domain){
          $campaigns.getDefaultLinkTrackingDomain()
          .then((response) => {
            if(response.data.data.link_tracking_domain){
              this.isDnsSetup = true
            }
            else{
              this.isDnsSetup = false
            }
          })
        }
        else{
          this.isDnsSetup = false
        }
      })
    },
  }
}